export enum SkillStatusEnum {
  BACKLOG = 'backlog',
  LEARNING = 'learning',
  COMPLETED = 'completed',
}
